import React, { useState, useEffect } from "react";
import { useProductRecommendations } from "../services/hooks/useProductRecommendations";
import Loader from "./Loader";
import RecommendedProductCard from "./RecommendedProductCard";
import openModal from "../util/openModal";
import time from "../services/time/time";
import StoreProductModal from "./StoreProductModal";

const ProductRecommendations = React.memo(
  ({
    product,
    products,
    title = "You may also like",
    className = "pt-11",
    style = {},
  }) => {
    const {
      productRecommendations,
      productRecommendationsStatus,
      productRecommendationsError,
      fetchProductRecommendations,
    } = useProductRecommendations();

    const [modalProduct, setModalProduct] = useState();

    const onShowProductModal = (product) => {
      //The "eTag" is added so that the state can update every time
      //a product view is triggered. Even if it was the same product.
      setModalProduct({ ...product, currentTime: time().unix() });
    };

    useEffect(() => {
      if (product || products) {
        fetchProductRecommendations({
          productId: product?.id,
          productIds: (products ?? []).map((product) => product.id),
        });
      }
    }, [product, products]);

    useEffect(() => {
      if (modalProduct) {
        openModal("#modalProduct");
      }
    }, [modalProduct]);

    if (productRecommendationsStatus !== "ready") {
      return (
        <section className={className} style={style}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <Loader />
              </div>
            </div>
          </div>
        </section>
      );
    }

    if (productRecommendationsError || !productRecommendations?.length) {
      return null;
    }

    return (
      <section className={className} style={style}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              {/* Heading */}
              <h4 className="mb-10 text-center">{title}</h4>
              {/* Items */}
              <div className="row">
                {productRecommendations.map((productRecommendation) => (
                  <RecommendedProductCard
                    product={productRecommendation}
                    onShowProductModal={onShowProductModal}
                    key={productRecommendation.id}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {modalProduct && <StoreProductModal product={modalProduct} />}
      </section>
    );
  }
);

export default ProductRecommendations;
